import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import {UserPopupContent} from "../../../visComponents/constants";
import {setUserPopupContent} from "../../../../actions/userFunctions";
import LeadCapturePopupFooterSubmit from "./leadCapturePopupFooterSubmit";
import {GroheNoteAddIcon} from "../../../common/icons";

const LeadCapturePopupFooter = (props) => {

  const {userPopupContent, updateInputValidations, setUserPopupContent, closePopup, isMobile} = props;

  const privacyClick = () => {
    setUserPopupContent(UserPopupContent.terms);
  }

  const toggleLoginClick = () => {
    setUserPopupContent(userPopupContent === UserPopupContent.register ? UserPopupContent.login : UserPopupContent.register);
  }

  const oneButtonOnly = userPopupContent !== UserPopupContent.login && userPopupContent !== UserPopupContent.register;

  return (
    <Fragment>
      <div className={"grohe-lead__footer" + (oneButtonOnly ? " grohe-lead__footer--terms" : "")}>
        {oneButtonOnly ? null : (
          <Fragment>
            <div className="grohe-lead__footer-cell">
              <div className="grohe-lead__link"  onClick={toggleLoginClick}>
                <div className="grohe-lead__link-text">
                  <FormattedMessage id={userPopupContent === UserPopupContent.register ? "leadCapturePopup.loginText" : "leadCapturePopup.registerText"}/>
                </div>
                <SvgIcon className="grohe-lead__link-icon">
                  {userPopupContent === UserPopupContent.register ? <AccountCircleIcon/> : <GroheNoteAddIcon/>}
                </SvgIcon>
                <FormattedMessage id={userPopupContent === UserPopupContent.register ? "leadCapturePopup.loginButton" : "leadCapturePopup.registerButton"}/>
              </div>
            </div>
            {userPopupContent === UserPopupContent.register && !isMobile ? (
              <div className="grohe-lead__footer-cell" onClick={privacyClick}>
                <span className="grohe-lead__link">
                  <FormattedMessage id="leadCapturePopup.privacyButton"/>
                </span>
              </div>
            ) : null}
          </Fragment>
        )}
        <LeadCapturePopupFooterSubmit updateInputValidations={updateInputValidations} closePopup={closePopup}/>
      </div>
      {userPopupContent === UserPopupContent.register && isMobile ? (
        <div className="grohe-lead__footer" onClick={privacyClick}>
          <span className="grohe-lead__link">
            <FormattedMessage id="leadCapturePopup.privacyButton"/>
          </span>
        </div>
      ) : null}
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {userPopupContent} = store.userState;
  const {isMobile} = store.serverState;
  return {
    userPopupContent,
    isMobile,
  };
};

LeadCapturePopupFooter.propTypes = {
  updateInputValidations: PropTypes.func.isRequired,
  closePopup: PropTypes.func.isRequired
}

const mapDispatchToProps = {
  setUserPopupContent
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopupFooter)
